<jf-form-block>
  <jf-form-field-text
    class="form-field-half-width"
    [formControl]="formControls.empfaenger"
    [label]="'Empfänger'"
    [message]="getEmpfaengerValidatorMessage()"
    (keyup)="doHighlightWords(formControls.empfaenger)"
    (focusin)="doHighlightWords(formControls.empfaenger)"
    (focusout)="doClearHighlighting()"
  ></jf-form-field-text>

  <jf-form-field-text-autocomplete
    class="form-field-half-width"
    [inputFormControl]="formControls.ibanInput"
    [label]="'IBAN'"
    [selectMode]="'onInput'"
    [options]="bankkontoOptions$ | async"
    [optionComponentType]="bankkontoOptionComponent"
    [message]="getIbanValidatorMessage()"
    (keyup)="doHighlightWords(formControls.ibanInput)"
    (focusin)="doHighlightWords(formControls.ibanInput)"
    (focusout)="doClearHighlighting()"
  ></jf-form-field-text-autocomplete>

  <jf-form-field-text
    class="form-field-half-width"
    [formControl]="formControls.bank"
    [label]="'Bank'"
    [message]="getBankValidatorMessage()"
    (keyup)="doHighlightWords(formControls.bank)"
    (focusin)="doHighlightWords(formControls.bank)"
    (focusout)="doClearHighlighting()"
  ></jf-form-field-text>

  <jf-form-field-text
    class="form-field-half-width"
    [formControl]="formControls.bic"
    [label]="'BIC'"
    [message]="getBicValidatorMessage()"
    (keyup)="doHighlightWords(formControls.bic)"
    (focusin)="doHighlightWords(formControls.bic)"
    (focusout)="doClearHighlighting()"
  ></jf-form-field-text>

  <jf-form-field-number
    class="form-field-half-width"
    [formControl]="formControls.zahlbetrag"
    [label]="'Zahlbetrag'"
    [thousandSeparator]="'.'"
    [decimalSeparator]="','"
    [decimalPlaces]="2"
    [min]="-99999999.99"
    [max]="99999999.99"
    [suffix]="'€'"
    [fillDecimals]="true"
    [message]="getZahlbetragValidatorMessage()"
    (keyup)="doHighlightWords(formControls.zahlbetrag)"
    (focusin)="doHighlightWords(formControls.zahlbetrag)"
    (focusout)="doClearHighlighting()"
  ></jf-form-field-number>

  <jf-form-field-text
    class="form-field-half-width"
    [formControl]="formControls.verwendungszweck"
    [label]="'Verwendungszweck'"
    [message]="getVerwendungszweckValidatorMessage()"
    (keyup)="doHighlightWords(formControls.verwendungszweck)"
    (focusin)="doHighlightWords(formControls.verwendungszweck)"
    (focusout)="doClearHighlighting()"
  ></jf-form-field-text>

  <jf-form-field-date
    class="form-field-half-width faelligkeitsdatum"
    [formControl]="formControls.faelligkeitsdatum"
    [labelOfSingleDateField]="'Fälligkeitsdatum'"
    [mode]="'single'"
    [minOfYearsRange]="2023"
    [maxOfYearsRange]="2050"
    (keyup)="doHighlightWords(formControls.faelligkeitsdatum)"
    (focusin)="doHighlightWords(formControls.faelligkeitsdatum)"
    (focusout)="doClearHighlighting()"
  ></jf-form-field-date>

</jf-form-block>
